import * as Sentry from '@sentry/vue'
import { isNavigationFailure } from 'vue-router'
import type { RouteLocationNormalized } from 'vue-router'
import { isStaleChunkReloadPending } from '@/plugins/staleChunkReload'

export function handleRouterError(
  error: unknown,
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
) {
  if (isNavigationFailure(error)) {
    return
  }
  console.error('[router]:', error)
  if (isStaleChunkReloadPending()) {
    return
  }
  Sentry.captureException(error, { extra: { to: to.fullPath, from: from.fullPath } })
}
